var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47412 7.54961V20.2436C4.47412 20.9939 4.75127 21.6985 5.23543 22.204C5.71735 22.711 6.38803 22.9988 7.08993 23H16.9101C17.6122 22.9988 18.2829 22.711 18.7646 22.204C19.2487 21.6985 19.5259 20.9939 19.5259 20.2436V7.54961C20.4883 7.29603 21.112 6.37306 20.9832 5.39273C20.8543 4.4126 20.0131 3.67942 19.0172 3.67922H16.3598V3.03519C16.3629 2.4936 16.1471 1.97355 15.7609 1.59096C15.3747 1.20857 14.85 0.99564 14.3044 1.00007H9.6956C9.15002 0.99564 8.62532 1.20857 8.23909 1.59096C7.85286 1.97355 7.63714 2.4936 7.64018 3.03519V3.67922H4.98281C3.98692 3.67942 3.14574 4.4126 3.01679 5.39273C2.88805 6.37306 3.51169 7.29603 4.47412 7.54961ZM16.9101 21.9696H7.08993C6.20252 21.9696 5.51217 21.2128 5.51217 20.2436V7.5949H18.4878V20.2436C18.4878 21.2128 17.7975 21.9696 16.9101 21.9696ZM8.67823 3.03519C8.67479 2.76691 8.78102 2.5087 8.97282 2.31931C9.16441 2.12993 9.42514 2.02588 9.6956 2.03051H14.3044C14.5749 2.02588 14.8356 2.12993 15.0272 2.31931C15.219 2.5085 15.3252 2.76691 15.3218 3.03519V3.67922H8.67823V3.03519ZM4.98281 4.70966H19.0172C19.5332 4.70966 19.9514 5.12485 19.9514 5.63706C19.9514 6.14926 19.5332 6.56445 19.0172 6.56445H4.98281C4.46682 6.56445 4.04856 6.14926 4.04856 5.63706C4.04856 5.12485 4.46682 4.70966 4.98281 4.70966Z",
    fill: "#18213A",
    stroke: "#18213A",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.92,
    y: 10,
    width: 1.52,
    height: 9.76,
    rx: 0.76,
    fill: "#18213A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.24,
    y: 10,
    width: 1.52,
    height: 9.76,
    rx: 0.76,
    fill: "#18213A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.56,
    y: 10,
    width: 1.52,
    height: 9.76,
    rx: 0.76,
    fill: "#18213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.761d776c19a5ff7cc1a6a95fe2bbe1f3.svg";
export { ForwardRef as ReactComponent };